<div class="splash-loader-container" *ngIf="!isDataLoaded">
    <svg
        class="splash-loader"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            class="splash-path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
        ></circle>
    </svg>
</div>
<ng-container *ngIf="isDataLoaded">
    <app-sb-print-layout
        *ngIf="isEnabledPrinting$ | async"
        [class]="(printLayout$ | async) ? 'd-block' : 'd-none'"
        [grid]="grid"
    ></app-sb-print-layout>
    <div
        class="container-xxl px-0 px-sm-3 pb-3 pb-lg-4 pb-xl-5"
        sbContainerSpacer
        [class]="!(printLayout$ | async) ? 'd-block' : 'd-none'"
    >
        <div *ngIf="grid.parentGridPath">
            <a (click)="goBack()" class="back-link">Go back</a>
        </div>
        <div
            class="row gy-4 gx-0 gx-sm-4 justify-content-center dashboard"
            *ngIf="grid && grid.panelLayouts"
        >
            <ng-container
                *ngFor="let panelLayout of grid.panelLayouts; trackBy: trackByPanelId"
            >
                <div
                    [class]="getLayoutClass(panelLayout)"
                    *ngIf="isPanelVisible(panelLayout.panelId)"
                >
                    <div *ngIf="hasPanelLayouts(panelLayout)" class="row gy-4">
                        <!-- Insert tab groups if any...  -->
                        <!-- Check if this panel has children who should be in a specific tab group -->
                        <div
                            *ngFor="let pl of panelLayout.panelLayouts; index as i"
                            [ngClass]="getLayoutClass(pl)"
                        >
                            <ng-container *ngIf="hasTabbedPanels(pl)">
                                <mat-tab-group
                                    (selectedTabChange)="handleTabChange($event)"
                                >
                                    <mat-tab
                                        *ngFor="
                                            let pane of pl.tabbedPanels;
                                            let tabIndex = index
                                        "
                                        label="{{ pane.tabHeader }}"
                                    >
                                        <app-sb-panel
                                            [panelId]="pane.panelId"
                                            [tabId]="tabIndex"
                                        ></app-sb-panel>
                                    </mat-tab>
                                </mat-tab-group>
                            </ng-container>
                            <ng-container *ngIf="hasTabbedPanels(pl) == false">
                                <ng-container
                                    *ngIf="
                                        pl.panelId === 'my-root-accounts-widget-panel' &&
                                        useLegacyAccountList !== true
                                    "
                                >
                                    <sb-account-list
                                        *ngIf="useLegacyAccountList !== 'balance-list'"
                                        [isStandalone]="false"
                                        class="d-block mt-4"
                                    ></sb-account-list>
                                    <sb-balance-list
                                        class="d-block mt-4"
                                        [isStandalone]="false"
                                        *ngIf="useLegacyAccountList === 'balance-list'"
                                    ></sb-balance-list>
                                </ng-container>
                                <app-sb-panel
                                    *ngIf="
                                        pl.panelId !== 'my-root-accounts-widget-panel' ||
                                        (pl.panelId === 'my-root-accounts-widget-panel' &&
                                            useLegacyAccountList === true)
                                    "
                                    [panelId]="pl.panelId"
                                ></app-sb-panel>
                                <sb-top-holdings
                                    class="d-block mt-4"
                                    *ngIf="pl.panelId === 'my-root-accounts-widget-panel'"
                                ></sb-top-holdings>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="hasPanelLayouts(panelLayout) == false">
                        <ng-container *ngIf="hasTabbedPanels(panelLayout)">
                            <!-- If the tabbed panels are comprised of transaction-forms - display cancel button -->
                            <div
                                *ngIf="displayCancelButton(panelLayout)"
                                class="cancel-wrapper"
                            >
                                <button
                                    mat-icon-button
                                    class="sb-panel-header-button"
                                    matTooltip="Cancel"
                                    (click)="cancel($event)"
                                >
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </div>
                            <mat-tab-group (selectedTabChange)="handleTabChange($event)">
                                <mat-tab
                                    *ngFor="
                                        let pane of panelLayout.tabbedPanels;
                                        let tabIndex = index
                                    "
                                    label="{{ pane.tabHeader }}"
                                >
                                    <app-sb-panel
                                        [panelId]="pane.panelId"
                                        [tabId]="tabIndex"
                                    ></app-sb-panel>
                                </mat-tab>
                            </mat-tab-group>
                        </ng-container>
                        <ng-container *ngIf="hasTabbedPanels(panelLayout) == false">
                            <app-sb-panel [panelId]="panelLayout.panelId"></app-sb-panel>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>
